import { UserRole } from "components/Login";

// Roles that can view the Dashboard, Inventory, and Posture
export const ENVIRONMENT_ROLES: UserRole[] = ["iamViewer", "owner", "iamOwner"];

// Roles that can view the Settings page
export const ENV_SETTINGS_ROLES: UserRole[] = ["iamOwner", "owner"];

// Roles that can view the JiT Routing rules tab
export const JIT_ROUTING_ROLES: UserRole[] = ["approver", "owner"];

// Roles that have access to any of the 'configuration' routes: Integrations, Rest State, P0 Management
export const CONFIG_ROUTES_ROLES: UserRole[] = ["approver", "owner"];

// Roles that can view the AI inventory page.
export const AI_INVENTORY_ROLES: UserRole[] = [
  "iamViewer",
  "owner",
  "iamOwner",
];
